function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { Field } from "react-final-form";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DEFAULT_DATE_FORMAT } from "../../../utils/consts";
var DatePickerField = function(_param) {
    var name = _param.name, views = _param.views, label = _param.label, maxDate = _param.maxDate, minDate = _param.minDate, validate = _param.validate, props = _object_without_properties(_param, [
        "name",
        "views",
        "label",
        "maxDate",
        "minDate",
        "validate"
    ]);
    return /*#__PURE__*/ _jsx(Field, {
        name: name,
        initialValue: null,
        allowNull: true,
        validate: validate,
        children: function(param) {
            var input = param.input;
            return /*#__PURE__*/ _jsx(DatePicker, _object_spread({
                inputFormat: DEFAULT_DATE_FORMAT,
                mask: props.inputFormat ? props.inputFormat.replace(/[^:\-\\/ ]/g, "_") : DEFAULT_DATE_FORMAT.replace(/[^:\-\\/ ]/g, "_"),
                views: views,
                label: label,
                maxDate: maxDate,
                minDate: minDate,
                renderInput: function(props) {
                    return /*#__PURE__*/ _jsx(TextField, _object_spread({}, props));
                }
            }, props, input));
        }
    });
};
export default DatePickerField;
